import React, { useState, useEffect } from 'react';
import Fuse from 'fuse.js';
import { useDispatch } from 'react-redux';
import {setSearchIsActive, setSearchTerm} from "../../Features/Misc/activeSlice";

function SearchBar({ onKeywordSelected }) {
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState("");
    const [matchedKeywords, setMatchedKeywords] = useState([]);

    // Sample keywords for searching
    const keywords = [
        "Sleep Apnea", "Insomnia", "Snoring", "CPAP",
        "Narcolepsy", "Sleep Paralysis", "Hypersomnia", "Sleepwalking",
        "Restless Legs Syndrome", "Bruxism", "Circadian Rhythm Disorders", "Nightmares",
        "Sleep Talking", "REM Sleep Behavior Disorder", "Jet Lag", "Shift Work",
        "Delayed Sleep Phase Syndrome", "Advanced Sleep Phase Syndrome", "Non-24-Hour Sleep-Wake Disorder",
        "Idiopathic Hypersomnia", "Sleep Hygiene", "Melatonin", "Sleep Deprivation",
        "Sleep Medicine", "Polysomnography", "Actigraphy", "Sleep Diary",
        "Sleep Study", "Light Therapy", "Sleep Education", "Bedtime Routine",
        "Sleep Environment", "Sleep Quality", "Deep Sleep", "Rapid Eye Movement",
        "Sleep Cycle", "Bedtime Anxiety", "Dream Analysis", "Sleep Aids",
        "Sleep Training", "Sleep Regression", "Sleep Analysis", "Sleep Schedule",
        "Sleep Tracker", "Bedtime Snack", "Sleep Efficiency", "Nocturnal",
        "Siesta", "Power Nap", "Sleep Debt", "Sleep Retreat",
        "Lavender Oil", "White Noise Machine", "Sleepwear", "Mattress",
        "Pillow", "Sleeping Pills", "Sleep Coach", "Sleep Consultant",
        "Sleep Therapy", "Sleep Disorder Clinic", "Sleep Tech", "Night Light",
        "Sleep Mask", "Earplugs", "Sleep App", "Bedtime Tea",
        "Sleep Ritual", "Sleep Innovation", "Sleep Research", "Sleep Science",
        "Sleep Data", "Sleep Statistics", "Sleep History", "Sleep Culture",
        "Sleep Myth", "Sleep Expert", "Sleep Benefit", "Sleep Recommendation",
        "Sleep Resource", "Sleep Awareness", "Sleep Support", "Sleep Wellness",
        "Sleep Relaxation", "Sleep Music", "Sleep Nutrition", "Sleep Fitness",
        "Sleep Technology", "Sleep Productivity", "Sleep Health", "Sleep Safety",
        "Sleep Awareness Campaign", "Sleep Workshop", "Sleep Seminar", "Sleep Conference",
        "Children", "Toddlers", "Balance", "Family", "Social Life", "Menopause",
        "Can’t Sleep", "Waking in the night", "Can't Get To sleep"
    ];

    // Initialize Fuse with the keywords
    useEffect(() => {
        const fuse = new Fuse(keywords, {
            includeScore: true,
            threshold: 0.3, // Adjust this value based on desired fuzziness
            keys: ["value"]
        });

        if (inputValue) {
            const results = fuse.search(inputValue).map(result => result.item);
            setMatchedKeywords(results);
        } else {
            setMatchedKeywords([]);
        }
    }, [inputValue]);


    const handleSelect = (keyword) => {
        dispatch(setSearchTerm(keyword));
        dispatch(setSearchIsActive());

        setInputValue('');
        setMatchedKeywords([]);
    };

    return (
        <>
            <div
                className={`w-full search-parent focus:outline-none justify-center items-center z-40 flex flex-col relative`}
            >
                <div className="relative w-full flex flex-row text-search-text-grey justify-center h-9">
                    <input
                        type={'text'}
                        placeholder={'Search'}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        className={`w-full rounded-lg px-2 text-base focus:outline-none`}
                    />
                    <i className="absolute top-0 right-2 ri-search-line bg-white"></i>
                </div>

                {/* Results container with absolute positioning */}
                {matchedKeywords.length > 0 && (
                    <div className={`absolute top-[calc(100%+0.5rem)] w-full overflow-y-auto max-h-60 z-50 bg-white rounded-t-lg rounded-b-lg`}>
                        {matchedKeywords.map((keyword, index) => (
                            <div
                                key={index}
                                onClick={() => handleSelect(keyword)}
                                className={`flex text-search-text-grey  items-center w-full px-1 py-1.5 hover:bg-pink-icon text-sm cursor-pointer transition-colors duration-300 ${
                                    index !== matchedKeywords.length - 1 ? 'border-b-2 border-gray-100' : ''
                                }`}
                            >
                                {keyword}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default SearchBar;